import { useFormikContext } from 'formik';
import React from 'react';
import { Button, SecondaryButton } from '@chegg-ui/button';
import { BUTTON_TEXT, TestIds } from './constants';
import { Divider, FormSubmitWrapper, SubmitSectionContainer } from './styled';
/**
 * Submit section form component for chegg writing center which will have cancel/create/update citation buttons
 */
var SubmitSection = function SubmitSection(_ref) {
  var isNewCitation = _ref.isNewCitation,
    showButtonsInVertical = _ref.showButtonsInVertical,
    backButtonText = _ref.backButtonText,
    onCancel = _ref.onCancel,
    adsEnabled = _ref.adsEnabled;
  var _useFormikContext = useFormikContext(),
    isSubmitting = _useFormikContext.isSubmitting,
    submitForm = _useFormikContext.submitForm;
  var submitButtonText = BUTTON_TEXT.COMPLETE_CITATION;
  var submitButtonTestId = TestIds.CREATE_CITATION;
  if (!isNewCitation) {
    submitButtonText = BUTTON_TEXT.UPDATE_CITATION;
    submitButtonTestId = TestIds.UPDATE_CITATION;
  }
  var cancelButtonText = backButtonText ? BUTTON_TEXT[backButtonText] : BUTTON_TEXT.CANCEL;
  return /*#__PURE__*/React.createElement(FormSubmitWrapper, {
    className: "form-buttons",
    "data-test": TestIds.FORM_SUBMIT_WRAPPER,
    adsEnabled: adsEnabled
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(SubmitSectionContainer, {
    role: "group",
    "aria-labelledby": "submit-label",
    adsEnabled: adsEnabled,
    showButtonsInVertical: showButtonsInVertical
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    variant: "text",
    id: "submit-label",
    "data-test": TestIds.CANCEL,
    disabled: isSubmitting,
    onClick: onCancel
  }, cancelButtonText), /*#__PURE__*/React.createElement(Button, {
    "data-test": submitButtonTestId,
    disabled: isSubmitting,
    disableHoverAnimation: true,
    isLoading: isSubmitting,
    onClick: submitForm
  }, submitButtonText)));
};
export default SubmitSection;